// Contact information constants
export const CONTACT_PHONES = [
  '9246789369',
  '9948999394',
  '9502942957'
];

export const PHONE_1 = CONTACT_PHONES[0];
export const PHONE_2 = CONTACT_PHONES[1];
export const PHONE_3 = CONTACT_PHONES[2];

// Property details
export const PROPERTY_NAME = 'Sree Kanaka Maha Lakshmi Nilayam';
export const PROPERTY_ADDRESS = {
  street: '7th Road, Sriram Nagar',
  area: 'Eluru, Sanivarapupeta',
  state: 'Andhra Pradesh',
  pincode: '534003',
  country: 'India'
};

export const PROPERTY_FULL_ADDRESS = `${PROPERTY_ADDRESS.street}, ${PROPERTY_ADDRESS.area}, ${PROPERTY_ADDRESS.state} ${PROPERTY_ADDRESS.pincode}`;
